import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-angular-collapse',
  template: `<div class="wrapper">

        <header (click)="show = !show;">
                <ng-content select="[header]"></ng-content>
        </header>
            
        <body [hidden]="!show">
                <ng-content select="[body]"></ng-content>
        </body>

</div>`,
  styles: [`.wrapper{width:80%;margin:0 auto;font-weight:350}header{padding:1rem;box-sizing:border-box;background-color:#f9f9f9}body{padding:1.5rem;background-color:#fff;font-size:.8rem}`]
})
export class AngularCollapseComponent implements OnInit {

  constructor() { }

  show = false;

  ngOnInit() {
  }

}
